import { render, staticRenderFns } from "./addRecordYouthToPlayer.vue?vue&type=template&id=8343ec06&scoped=true&"
import script from "./addRecordYouthToPlayer.vue?vue&type=script&lang=js&"
export * from "./addRecordYouthToPlayer.vue?vue&type=script&lang=js&"
import style0 from "./addRecordYouthToPlayer.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./addRecordYouthToPlayer.vue?vue&type=style&index=1&id=8343ec06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8343ec06",
  null
  
)

export default component.exports